module.exports = __webpack_public_path__ + "img/msg.d1462925.svg";